import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

const handle = (error, fallback) => {
    if (error.response?.data) throw error.response.data;
    throw error.message || fallback;
};

export const getFromCCList = async (uid, rid) => {
    try {
        const res = await axios.get(`${base}/Purchase/Getnewstocktransferccs`, { params: { UID: uid, RID: rid } });
        return res.data;
    } catch (error) { return handle(error, 'Failed to fetch From Cost Centres'); }
};

export const getRecievedCCList = async (uid, rid) => {
    try {
        const res = await axios.get(`${base}/Purchase/Getnewstockrecievedccs`, { params: { UID: uid, RID: rid } });
        return res.data;
    } catch (error) { return handle(error, 'Failed to fetch To Cost Centres'); }
};

export const getCategories = async () => {
    try {
        const res = await axios.get(`${base}/Purchase/Getnewstockcategories`);
        return res.data;
    } catch (error) { return handle(error, 'Failed to fetch categories'); }
};

// SearchItem label format is "ItemCode , ItemName,Units   ||    Quantity" (spGetAutoCompletenewstockItemTransfer)
export const autoCompleteItem = async ({ prefix, type, cat, cc }) => {
    try {
        const res = await axios.get(`${base}/Purchase/AutoCompletenewItemTransfer`, { params: { Pfx: prefix, Typ: type, Cat: cat, CC: cc } });
        return res.data;
    } catch (error) { return handle(error, 'Failed to search items'); }
};

// Per-lot rows (MRR/PO batches) available for one item at one CC
export const getTempDetails = async (itemcode, cccode) => {
    try {
        const res = await axios.get(`${base}/Purchase/GetNewItemsTransferTempDetails`, { params: { Itemcode: itemcode, CCcode: cccode } });
        return res.data;
    } catch (error) { return handle(error, 'Failed to fetch item lot details'); }
};

// Stages the assigned quantities from the per-lot rows into the cart (NewStockTransferItemcodeDetails)
export const saveTempItems = async (payload) => {
    try {
        const res = await axios.post(`${base}/Purchase/SaveTempNewItemsTransfer`, payload);
        return res.data;
    } catch (error) { return handle(error, 'Failed to add item to transfer'); }
};

// The staged cart grid for one From CC
export const getCartGrid = async (cccode) => {
    try {
        const res = await axios.get(`${base}/Purchase/GetGetViewNewTransferItemsGridView`, { params: { CCcode: cccode } });
        return res.data;
    } catch (error) { return handle(error, 'Failed to fetch transfer cart'); }
};

export const deleteCartItem = async (payload) => {
    try {
        const res = await axios.post(`${base}/Purchase/DeleteNewStockItems`, payload);
        return res.data;
    } catch (error) { return handle(error, 'Failed to delete item'); }
};

export const saveTransfer = async (payload) => {
    try {
        const res = await axios.post(`${base}/Purchase/SaveNewItemsTransfer`, payload);
        return res.data;
    } catch (error) { return handle(error, 'Failed to submit transfer'); }
};
